import { FileTreeFile } from "./file-tree-file";
import { FileTreeSub } from "./file-tree-sub";

export const FileTreeContents = (props) => {
    
    const setPath = (path) => props.setPath(path);

    const pathData = { path: '/', contents: props.contents };

    return (
        <div className="file-node has-sub expand selected">
            <a href="#/" className="file-link" onClick={e => { e.stopPropagation(); setPath(pathData); }}>
                <span className="file-arrow"></span>
                <span className="file-info">
                    <span className="file-icon"><i className="fa fa-folder fa-lg text-warning"></i></span>
                    <span className="file-text">{props.rootFolderName}</span>
                </span>
            </a>
            <div className="file-tree">

                {props.contents && Array.isArray(props.contents) && props.contents.map((item, i) => {
                    return item.isFolder ?
                        <FileTreeSub key={`tree-sub-${i}`} getImage={props.getImage} folder={item} parent={item.parent} setPath={setPath} />
                        :
                        <FileTreeFile key={`tree-file-${i}`} getImage={props.getImage} file={item} parent={item.parent} setPath={setPath} />
                }
                )}
            </div>
        </div>
    );
};